import { useEffect } from 'react'

/**
 * Предупредить браузером при перезагрузке/закрытии вкладки, пока есть
 * несохранённый черновик или команда 1С без итога: и то и другое живёт только
 * в памяти страницы (срок `screen`).
 */
export function useUnsavedGuard(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [active])
}
